export const AUDIO_MODEL_PRIVACY_MIGRATION_KEY = 'qm_audio_model_privacy_migration_v5_46_88';
export const CRM_MIGRATION_MARKER_BASE_KEY = 'qm_crm_migration_v2';
export const LEARNING_MAINTENANCE_MARKER_BASE_KEY = 'qm_last_decay';
export const PROPERTY_MIGRATION_MARKER_BASE_KEY = 'qm_property_migration_v1';

/**
 * Build a browser-persistent marker key for tenant-owned work.
 *
 * localStorage is shared by every account on one QuoteMaker origin. A tenant
 * suffix prevents one signed-in workspace from suppressing maintenance for a
 * different workspace that later uses the same browser profile.
 */
export function buildTenantRuntimeStorageKey(
    baseKey: string,
    tenantId: string | null | undefined,
): string | null {
    const base = String(baseKey || '').trim();
    const tenant = String(tenantId || '').trim();
    if (!base || !tenant) return null;
    return `${base}:${encodeURIComponent(tenant)}`;
}
